"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomContent = exports.Link = exports.SmallTokens = exports.TokenDispalySmall = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("../../styles");
var base_1 = require("../base");
var hooks_1 = require("./hooks");
var FaArrowRight_1 = require("@react-icons/all-files/fa/FaArrowRight");
var react_1 = require("react");
var hooks_2 = require("../../hooks");
var styled_components_1 = require("styled-components");
var context_1 = require("../../context/context");
var TokenDispalySmall = function (_a) {
    var isSrc = _a.isSrc;
    var _b = (0, hooks_1.useTokenDisplay)(isSrc), amount = _b.amount, token = _b.token;
    var isMarketOrder = (0, hooks_2.useIsMarketOrder)();
    var swapState = (0, context_1.useTwapContext)().state.swapState;
    var prefix = (0, react_1.useMemo)(function () {
        if (!isSrc || !isMarketOrder)
            return "";
        return swapState === "success" ? "Allocated" : "Allocate";
    }, [isSrc, isMarketOrder]);
    return ((0, jsx_runtime_1.jsxs)(StyledTokenDispalySmall, __assign({ className: "twap-order-modal-token-small" }, { children: [prefix && (0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: prefix }), (0, jsx_runtime_1.jsx)(styles_1.StyledText, __assign({ className: "twap-order-modal-token-small-text" }, { children: "".concat(!isSrc && isMarketOrder ? "" : amount, " ").concat(token === null || token === void 0 ? void 0 : token.symbol) })), (0, jsx_runtime_1.jsx)(base_1.TokenLogo, { logo: token === null || token === void 0 ? void 0 : token.logoUrl })] })));
};
exports.TokenDispalySmall = TokenDispalySmall;
var StyledTokenDispalySmall = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    width: "auto",
    gap: 6,
    ".twap-token-logo": {
        width: 18,
        height: 18,
    },
    ".twap-order-modal-token-small-text": {
        fontSize: 14,
    },
});
var SmallTokens = function () {
    return ((0, jsx_runtime_1.jsxs)(StyledSmallTokens, { children: [(0, jsx_runtime_1.jsx)(exports.TokenDispalySmall, { isSrc: true }), (0, jsx_runtime_1.jsx)(StyledSmallTokensArrow, { children: (0, jsx_runtime_1.jsx)(FaArrowRight_1.FaArrowRight, {}) }), (0, jsx_runtime_1.jsx)(exports.TokenDispalySmall, {})] }));
};
exports.SmallTokens = SmallTokens;
var StyledSmallTokensArrow = (0, styled_components_1.styled)("div")({
    display: "flex",
    alignItems: "center",
    svg: {
        width: 12,
        height: 12,
    },
});
var StyledSmallTokens = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    justifyContent: "center",
    alignItems: "center",
});
var Link = function (_a) {
    var href = _a.href, children = _a.children, onClick = _a.onClick;
    return ((0, jsx_runtime_1.jsx)(StyledLink, __assign({ onClick: onClick, href: href, target: "_blank", className: "twap-order-modal-link" }, { children: children })));
};
exports.Link = Link;
var StyledLink = (0, styled_components_1.styled)("a")({
    color: "rgb(252, 114, 255)",
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 500,
});
var BottomContent = function (_a) {
    var href = _a.href, text = _a.text;
    var content;
    if (href) {
        content = ((0, jsx_runtime_1.jsx)(StyledLink, __assign({ href: href, target: "_blank", className: "twap-order-modal-link" }, { children: text })));
    }
    else {
        content = (0, jsx_runtime_1.jsx)(StyledBottomContentText, { children: text });
    }
    return (0, jsx_runtime_1.jsx)(StyledBottomContent, __assign({ className: "twap-order-modal-bottom-content" }, { children: content }));
};
exports.BottomContent = BottomContent;
var StyledBottomContent = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    marginTop: 40,
    alignItems: "center",
});
var StyledBottomContentText = (0, styled_components_1.styled)(styles_1.StyledText)({
    textAlign: "center",
    color: "rgb(155, 155, 155)",
    fontSize: 14,
    fontWeight: 500,
});
